module.exports = __webpack_public_path__ + "assets/w3w_logo@2x-dbf7b9a22f5970afa3fe9c3a022351e0.png";